import { addAgeToLocalStorage } from '@app-studio-web/ui/helpers/localStorage'
import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'

const answers: AnswerType[] = [
  {
    emoji: '🧑',
    title: 'pages.onboarding.ageQuestion.answer1',
    value: '18_24',
  },
  {
    emoji: '🧑‍💼',
    title: 'pages.onboarding.ageQuestion.answer2',
    value: '25_34',
  },
  {
    emoji: '👨',
    title: 'pages.onboarding.ageQuestion.answer3',
    value: '35_44',
  },
  {
    emoji: '🧓',
    title: 'pages.onboarding.ageQuestion.answer4',
    value: '45_54',
  },
  {
    emoji: '👴',
    title: 'pages.onboarding.ageQuestion.answer5',
    value: '55_64',
  },
  {
    emoji: '🎖️',
    title: 'pages.onboarding.ageQuestion.answer6',
    value: '65_plus',
  },
  {
    emoji: '💫',
    title: 'pages.onboarding.ageQuestion.answer7',
    value: 'other',
  },
]

export default function AgePage() {
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const selected = (event.target as HTMLInputElement).value
    if (selected) addAgeToLocalStorage(selected)
  }

  return (
    <SingleChoiceQuestionPage
      answers={answers}
      onSubmit={handleSubmit}
      subtitle="pages.onboarding.ageQuestion.subtitle"
      title="pages.onboarding.ageQuestion.title"
    />
  )
}
